import { z } from 'zod'

export const rechargedPhoneSchema = z.object({
  phoneNumber: z.string(),
  documentNumber: z.string(),
  fullName: z.string(),
  rechargeCount: z.number(),
  lastRechargeAt: z.string()
})
export type RechargedPhone = z.infer<typeof rechargedPhoneSchema>

export const transferPartySchema = z.object({
  walletId: z.number(),
  walletPublicId: z.string(),
  documentNumber: z.string(),
  phone: z.string(),
  fullName: z.string(),
  transferCount: z.number(),
  lastTransferAt: z.string()
})
export type TransferParty = z.infer<typeof transferPartySchema>

export const mobilePaymentPhoneSchema = z.object({
  phoneNumber: z.string(),
  paymentCount: z.number(),
  lastUsedAt: z.string()
})
export type MobilePaymentPhone = z.infer<typeof mobilePaymentPhoneSchema>

export const addressSchema = z.object({
  address: z.string(),
  source: z.string()
})
export type Address = z.infer<typeof addressSchema>

export const paymentMobileAndAddressesSchema = z.object({
  mobilePaymentPhones: z.array(mobilePaymentPhoneSchema),
  addresses: z.array(addressSchema)
})
export type PaymentMobileAndAddresses = z.infer<
  typeof paymentMobileAndAddressesSchema
>

export const loginActivitySchema = z.object({
  userClientId: z.number(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  lastActivity: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  source: z.string()
})
export type LoginActivity = z.infer<typeof loginActivitySchema>

export const activitySummarySchema = z.object({
  clientId: z.number(),
  documentNumber: z.string(),
  fullName: z.string(),
  phone: z.string(),
  email: z.string(),
  walletPublicId: z.string(),
  rechargedPhones: z.array(rechargedPhoneSchema),
  transferRecipients: z.array(transferPartySchema),
  transferSenders: z.array(transferPartySchema),
  paymentMobileAndAddresses: paymentMobileAndAddressesSchema,
  loginActivities: z.array(loginActivitySchema)
})
export type ActivitySummary = z.infer<typeof activitySummarySchema>
